module.exports = __webpack_public_path__ + "static/media/mobile-step2-ar.bfd452f4.png";